import { Skeleton } from "@capacit-com/lara-law-shared-ui";

const CommentComponentSkeleton = () => {
  return (
    <>
      {Array.from({ length: 6 }).map((_, index) => (
        <div key={index} className="relative w-full flex gap-2 mb-4">
          <Skeleton className="h-[32px] w-[32px] min-h-[32px] min-w-[32px] rounded-full bg-muted animate-pulse" />
          <div className="w-full border rounded-xl overflow-hidden shadow-xs">
            {/* Header skeleton */}
            <div className="p-2 border-b dark:border-b-gray-500/50 mx-2">
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2">
                  <Skeleton className="h-5 w-24 rounded-[2px] animate-pulse" />
                  <Skeleton className="h-5 w-px" />
                  <Skeleton className="h-5 w-20 rounded-[2px] animate-pulse" />
                </div>
                <Skeleton className="h-4 w-16 rounded-[2px] animate-pulse" />
              </div>
            </div>

            {/* Content skeleton */}
            <div className="mx-2 px-2 py-3">
              <Skeleton className="h-8 w-full rounded-sm animate-pulse" />
            </div>

            {/* Footer skeleton */}
            <div className="flex justify-end border-t dark:border-t-gray-500/50 py-2 px-0 mx-2">
              <div className="flex items-center gap-2">
                <Skeleton className="h-5 w-16 rounded-md animate-pulse" />
                <Skeleton className="h-6 w-px" />
                <Skeleton className="h-5 w-16 rounded-md animate-pulse" />
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default CommentComponentSkeleton;
